import Phaser from "phaser";
import LoadingScene from "@/games/MiniGame/Foraging/scenes/LoadingScene";
import RoundStartScene from "@/games/MiniGame/Foraging/scenes/RoundStartScene";
import QuestionScene from "@/games/MiniGame/Foraging/scenes/QuestionScene";
import PlayScene from "@/games/MiniGame/Foraging/scenes/PlayScene";
import AnsCorrectPlayScene from "@/games/MiniGame/Foraging/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/games/MiniGame/Foraging/scenes/AnsWrongPlayScene";
import BossScene from "@/games/MiniGame/Foraging/scenes/BossScene";
import LandingScene from "@/games/MiniGame/Foraging/scenes/LandingScene";
import Settings from "@/games/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
